import React, { Component } from 'react';
import './Categories.css';
import TvsC from '../images/TVs Categorie.jpg'
import LaptopC from '../images/Laptop Categorie.png'
import ConsoleC from '../images/Console Categorie.png'
import PhoneC from '../images/Phone Categorie.png'

class Catagories extends Component {
    render() {
        return (
            <div>
                <div className="container my-5">
                    <div className="row categories">
                        <a href="#" className="mx-auto my-sm-0 my-lg-5 p-0 col-3">
                            <div className="mx-auto ">
                                <img src={TvsC} alt="" />
                                <h5 className="mt-3">TVs</h5>
                            </div>
                        </a>
                        <a href="#" className="mx-auto my-sm-0 my-lg-5 p-0 col-3">
                            <div className="mx-auto ">
                                <img src={LaptopC} alt="" />
                                <h5 className="mt-3">Laptops</h5>
                            </div>
                        </a>
                        <a href="#" className="mx-auto my-sm-0 my-lg-5 p-0 col-3">
                            <div className="mx-auto ">
                                <img src={ConsoleC} alt="" />
                                <h5 className="mt-3">Consoles</h5>
                            </div>
                        </a>
                        <a href="#" className="mx-auto my-sm-0 my-lg-5 p-0 col-3">
                            <div className="mx-auto ">
                                <img src={PhoneC} alt="" />
                                <h5 className="mt-3">Phones</h5>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Catagories;
